import React, { useState, useEffect } from "react";
import "../Surveys.css";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//paparse
import { parse} from "papaparse";

//components
import SurveyNational from "../../reusable/SurveyNational/SurveyNational";

//assets
import TEXT from "../../../utils/text/surveys_national.json";

async function getData(url) {
     const data = parse(await fetchCsv(url), { header: true });
     return data.data;
}

async function fetchCsv(url) {
    const response = await fetch(url);
    const reader = response.body.getReader();
    const result = await reader.read();
    const decoder = new TextDecoder('utf-8');
    const csv = await decoder.decode(result.value);
    return csv;
}

export default function CostaRica({ survey }) {
    //language
    const { language } = useCurrentLanguage();

    //useState - data
    const [data, setData] = useState([]);

    //useState - questions
    const [questions, setQuestions] = useState([]);

    //useEffect
    useEffect(() => {
        if(survey !== '') handleGetData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [survey]);

    //handle get data
    const handleGetData = async () => {
        const csv1 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}costa_rica_q1.csv`);
        const csv2 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}costa_rica_q2.csv`);
        const csv3 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}costa_rica_q3.csv`);
        const csv4 = await getData(`/surveysNational/${language === 'en' ? '/en/' : ''}costa_rica_q4.csv`);

        let data1 = csv1.map((e) => ({value: Number(e['Porcentaje']), name: e['categoria']}))
        let data2 = [csv2.map((e) => e['categoria']), csv2.map((e) => Number(e['Porcentaje']))];
        let data3 = [csv3.map((e) => e['categoria']), csv3.map((e) => Number(e['Porcentaje']))];
        let data4 = [csv4.map((e) => e['categoria']), csv4.map((e) => Number(e['Porcentaje']))];

        let temp = [
            {
                id: "q1",
                question: TEXT['CRI']['q1']['question'][language],
                source: TEXT['CRI']['q1']['source'][language],
                description: TEXT['CRI']['q1']['description'][language],
                data: data1,
                graphType: "pie",
                hasOptions: false,
                survey: TEXT['CRI']['q1']['survey'][language],
                link: TEXT['CRI']['q1']['link']
            },
            {
                id: "q2",
                question: TEXT['CRI']['q2']['question'][language],
                source: TEXT['CRI']['q2']['source'][language],
                description: TEXT['CRI']['q2']['description'][language],
                data: data2,
                graphType: "bar",
                hasOptions: false,
                survey: TEXT['CRI']['q2']['survey'][language],
                link: TEXT['CRI']['q2']['link']
            },
            {
                id: "q3",
                question: TEXT['CRI']['q3']['question'][language],
                source: TEXT['CRI']['q3']['source'][language],
                description: TEXT['CRI']['q3']['description'][language],
                data: data3,
                graphType: "bar",
                hasOptions: false,
                survey: TEXT['CRI']['q3']['survey'][language],
                link: TEXT['CRI']['q3']['link']
            },
            {
                id: "q4",
                question: TEXT['CRI']['q4']['question'][language],
                source: TEXT['CRI']['q4']['source'][language],
                description: TEXT['CRI']['q4']['description'][language],
                data: data4,
                graphType: "bar",
                hasOptions: false,
                survey: TEXT['CRI']['q4']['survey'][language],
                link: TEXT['CRI']['q4']['link']
            },
        ]
        let tempQ = []
        temp.forEach((e) => {
            if(e.survey === survey) tempQ.push({code: e.id, label: e.question})
        })
        console.log(temp)
        setData(temp.filter((el) => el.survey === survey))
        setQuestions(tempQ);
     }

     return (
       <div>
          <SurveyNational data={data} questions={questions} title={survey}/>
       </div>
  );
}
